import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import AuthContext from '../context/AuthProvider'
import "../style/Navmenu.css"




const Navmenu = (props) => {
    const { isMenuOpen, setIsMenuOpen,setisAuthenticatedUser } = useContext(AuthContext)
    const meHuParameter = "meHuParameter"
    const handleCloseMenu = () => {
        setIsMenuOpen(!isMenuOpen)
    }

    const handleLogoutPopup = () => {
        localStorage.clear()
        setisAuthenticatedUser(false)
    }

    return (
        <div className='navmenu' onBlur={handleCloseMenu}>

            <div className='items' onClick={() => { handleCloseMenu() }} style={{ height: "auto" }}>
                <Link className='profile' to={`/profile`}>Profile</Link>
                <Link className='profile' to={`/booking`}>Bookings</Link>
                <Link className='profile' onClick={handleLogoutPopup} to={`/`}>Logout</Link>

            </div>

        </div>
    )
}

export default Navmenu